import React, { useCallback, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

export const PAGE_SIZE = 20;

export const STATUS_FILTERS = [
  { value: 'pending', label: 'Pending' },
  { value: 'actioned', label: 'Actioned' },
  { value: 'dismissed', label: 'Dismissed' },
  { value: 'all', label: 'All' },
];

export const formatDateTime = (value) => {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(value);
  return parsed.toLocaleString();
};

export const formatPhone = (phone) => {
  if (!phone) return '—';
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length === 10) return `+91 ${digits}`;
  if (digits.length > 10) return `+${digits}`;
  return String(phone);
};

export function useReportSession() {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const showSnackbar = useCallback((message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const handleSessionExpired = useCallback(
    (res) => {
      if (String(res?.statusCode || '') === '10003') {
        showSnackbar('Session expired. Please login again.', 'error');
        setTimeout(() => {
          window.location = '/login';
        }, 1500);
        return true;
      }
      return false;
    },
    [showSnackbar]
  );

  const snackbarEl = (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity={snackbar.severity}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        variant="filled"
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );

  return { showSnackbar, handleSessionExpired, snackbarEl };
}
